import PropTypes from "prop-types"
import React from "react"
import {Col, FormGroup, Label} from "reactstrap"
import Tooltip from "./tooltip"
import { withTranslation } from "react-i18next"

const FormInputSwitch = props => {
  const { attribute, description, value, setValue, trueValue, falseValue, disabled, title, keyTranslate, additionalText, labelColumns } = props

  return (
    <React.Fragment>
      <FormGroup className="mb-4" row>
        <Label htmlFor={ attribute + "-switch" } className={ "col-form-label " + (labelColumns ? 'col-lg-' + labelColumns : 'col-lg-2')}>
          { keyTranslate ? props.t(keyTranslate + '.label') : description }
          { keyTranslate && <Tooltip id={ attribute + "-title"} tooltip={ props.t(keyTranslate + '.title') }></Tooltip>}
        </Label>
        <Col lg={labelColumns ? labelColumns : '10'}>
          <div className="square-switch">
            <input
              type="checkbox"
              id={ attribute + "-switch" }
              name={ attribute + "-switch"}
              switch="none"
              checked={ value === (trueValue || 'S') }
              onChange={ () => {
                setValue(value === (trueValue || 'S') ? (falseValue !== undefined ? falseValue : 'N') : (trueValue || 'S') )
              } }
              disabled={ disabled }
              title={ keyTranslate ? props.t(keyTranslate + '.title') : title}
            />
            <label
              htmlFor={ attribute + "-switch"}
              data-on-label="Sim"
              data-off-label="Não"
            />
            { additionalText &&
              <span name="additional-text" id={ `additional-text-${ attribute }` }>
              { additionalText }
            </span>
            }
          </div>
        </Col>
      </FormGroup>

    </React.Fragment>
  )
}

FormInputSwitch.propTypes = {
  attribute: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.any,
  setValue: PropTypes.func,
  trueValue: PropTypes.any,
  falseValue: PropTypes.any,
  labelColumns: PropTypes.number,
  disabled: PropTypes.bool
}

export default withTranslation()(FormInputSwitch)
